module.exports = __webpack_public_path__ + "static/media/06_MLPS-2.0-C-14.0-1 1.bff810d6.png";